// extracted by css-extract-rspack-plugin
export default {"root":"root-n0CLUB","header":"header-NlScnI","title":"title-bHliXt","body":"body-hql1Lu"};